const maxDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

export default () => ({
  profile: {
    name: null,
    email: null,
    birthdate: null,
    contact_name_first: null,
    contact_phone_first: null,
    contact_name_second: null,
    contact_phone_second: null,
    country_register: null,
    phone: null,
    sms: false
  },
  maxDate: maxDateNow(),
  errors: {},
  format: 'DD/MM/YYYY',
  lang: {
    formatLocale: {
      firstDayOfWeek: 1
    },
    monthBeforeYear: false
  }
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/account-settings/resources/data.js